// In your Alpine store initialization
const onboarding = {
  showWelcome: !localStorage.getItem("onboarding_completed"),

  completeOnboarding() {
    localStorage.setItem("onboarding_completed", "true");
    this.showWelcome = false;
  },

  resetOnboarding() {
    localStorage.removeItem("onboarding_completed");
    this.showWelcome = true;
  },
};

export default onboarding;
